var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPlus = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "white",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74984 2.66699C8.74984 2.25278 8.41405 1.91699 7.99984 1.91699C7.58562 1.91699 7.24984 2.25278 7.24984 2.66699H8.74984ZM7.24984 13.3337C7.24984 13.7479 7.58562 14.0837 7.99984 14.0837C8.41405 14.0837 8.74984 13.7479 8.74984 13.3337H7.24984ZM13.3332 8.75033C13.7474 8.75033 14.0832 8.41454 14.0832 8.00033C14.0832 7.58611 13.7474 7.25033 13.3332 7.25033L13.3332 8.75033ZM2.6665 7.25032C2.25229 7.25032 1.9165 7.58611 1.9165 8.00032C1.9165 8.41454 2.25229 8.75032 2.6665 8.75032L2.6665 7.25032ZM7.24984 2.66699V13.3337H8.74984V2.66699H7.24984ZM13.3332 7.25033L2.6665 7.25032L2.6665 8.75032L13.3332 8.75033L13.3332 7.25033Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plus.5517aebd.svg";
export { ForwardRef as ReactComponent };